import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { keyframes } from 'styled-components/macro';
import tw from 'tailwind.macro';
import { H0, H4 } from '../../../../components/Typographies/Title';
import { HIGHLIGHTS, IHighlightImageProps, IHighlightProps } from './constants';
import { homePageHighlightMessages } from './messages';

const HighlightContainer = styled.div`
  ${tw`flex flex-col text-center`}
  width:fit-content;
  gap: var(--size-small);

  @media (min-width: 768px) {
    gap: var(--size-medium);
  }
`;

export const pop = keyframes`
  50%  {transform: scale(1.2);
`;

const Score = styled(H0)<IHighlightImageProps>`
  ${tw`relative`}

  &:hover {
    animation: ${pop} 1s linear infinite;
  }

  &:after {
    content: url(${({ icon }) => icon});
    position absolute;
    
    ${({ top }) => top !== undefined && `top:${top}px;`}
    ${({ bottom }) => bottom !== undefined && `bottom:${bottom}px;`}
    ${({ left }) => left !== undefined && `left:${left}px;`}
    ${({ right }) => right !== undefined && `right:${right}px;`}
  }
`;

const Highlight: React.FC<IHighlightProps> = ({
  children,
  icon,
  iconPosition,
  score,
}) => (
  <HighlightContainer>
    <Score
      as="p"
      bottom={iconPosition.bottom}
      icon={icon}
      left={iconPosition.left}
      right={iconPosition.right}
      top={iconPosition.top}
    >
      {score}
    </Score>
    <H4 as="span">{children}</H4>
  </HighlightContainer>
);

const Container = styled.div`
  ${tw`bg-beige-500 my-big rounded-30 py-big px-medium2 flex flex-col items-center 
  md:flex-row md:justify-around md:p-huge`}
  flex-wrap:wrap;
  gap: var(--size-huge2);
`;

const Highlights = () => (
  <Container>
    {HIGHLIGHTS.map((hilight, index) => (
      <Highlight
        key={index}
        icon={hilight.icon}
        iconPosition={hilight.iconPosition}
        score={hilight.score}
      >
        <span>
          <FormattedMessage
            {...homePageHighlightMessages[hilight.description]}
          />
        </span>
      </Highlight>
    ))}
  </Container>
);

export default Highlights;
